
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/visitor/traffic",
      function () {
        return require("private-next-pages/visitor/traffic/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/visitor/traffic"])
      });
    }
  